<template>
	<div id="misDatos">
		<b-form @submit.prevent="onSubmit()">

			<form-signup v-model="form" title="Datos de personales"/>

			<b-button type="submit" class="btn-red btn-form" variant="primary" :disabled="disabled">
				Guardar cambios
			</b-button>

		</b-form>

		<sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block" ref="modal">
			<div class="fa-3x" v-if="modal.icon == ''"><i class="fas fa-spinner fa-pulse"></i></div><br />
			{{ modal.msg }}
			<div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
				<b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close();">OK</b-button>
			</div>
		</sweet-modal>
	</div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import formSignup from '../daniel/form-signup.vue'

export default {
	// COMPONENTS
	components: { formSignup },

	// DATA
	data() {
		return {
			states: [],
			towns: [],
			disabled: false,
			form: null,

			modal: {
				msg: '',
				icon: '',
				block: false,
			},
		}
	},

	// COMPUTED
	computed: {
		...mapGetters(['getUser'])
	},

	// MOUNTED
	mounted(){
		this.form = _.clone(this.getUser)
	}
}
</script>

<style lang="less">
#misDatos {}
</style>